"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityStreamCommentBox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = require("../../components/Button");
var LayoutSection_1 = require("../../components/LayoutSection");
var MultiFileUpload_1 = require("../../components/MultiFileUpload");
var Row_1 = require("../../components/Row");
var Select_1 = require("../../components/Select");
var Stack_1 = require("../../components/Stack");
var TextArea_1 = require("../../components/TextArea");
var react_1 = require("react");
var ActivityStreamCommentBox = function (_a) {
  var _b, _c;
  var commentBoxTitle = _a.commentBoxTitle,
    commentPlaceholder = _a.commentPlaceholder,
    commentSendButton = _a.commentSendButton,
    visibleToEveryone = _a.visibleToEveryone,
    visibleToInternal = _a.visibleToInternal,
    visibleToAdvertisers = _a.visibleToAdvertisers,
    multiFileUploadProps = _a.multiFileUploadProps,
    multiFileUploadHook = _a.multiFileUploadHook,
    attachmentTitle = _a.attachmentTitle,
    _d = _a.visibilityOptions,
    visibilityOptions = _d === void 0 ? [] : _d,
    _e = _a.visibilitySelection,
    visibilitySelection = _e === void 0 ? true : _e,
    initialVisibilityState = _a.initialVisibilityState,
    commentSubmitDisabled = _a.commentSubmitDisabled,
    commentSubmitSpinner = _a.commentSubmitSpinner,
    onCommentSubmit = _a.onCommentSubmit;
  var _f = __read((0, react_1.useState)(""), 2),
    text = _f[0],
    setText = _f[1];
  var _g = __read((0, react_1.useState)(initialVisibilityState), 2),
    visibleTo = _g[0],
    setVisibleTo = _g[1];
  var usfu = (0, MultiFileUpload_1.useMultiFileUpload)();
  var hook = multiFileUploadHook !== null && multiFileUploadHook !== void 0 ? multiFileUploadHook : usfu;
  var comment = {
    visibleTo: visibleTo !== null && visibleTo !== void 0 ? visibleTo : "internal",
    text: text.trim(),
    attachment: hook.files
  };
  var options = (0, react_1.useMemo)(function () {
    return [{
      label: visibleToInternal,
      value: "internal"
    }, {
      label: visibleToAdvertisers,
      value: "advertisers"
    }, {
      label: visibleToEveryone,
      value: "all"
    }].filter(function (o) {
      return visibilityOptions.includes(o.value);
    });
  }, [visibilityOptions]);
  var _h = __read((0, react_1.useState)(false), 2),
    commentBoxExpanded = _h[0],
    setCommentBoxExpanded = _h[1];
  var _onCommentSubmit = function () {
    onCommentSubmit(comment);
    hook.clearFiles();
    setText("");
  };
  return (0, jsx_runtime_1.jsx)(LayoutSection_1.PureLayoutSection, __assign({
    expanded: commentBoxExpanded,
    setExpanded: setCommentBoxExpanded,
    label: (0, jsx_runtime_1.jsx)("div", __assign({
      className: "vsx-activity-stream-comment-box-title",
      style: {
        lineHeight: "32px"
      }
    }, {
      children: commentBoxTitle
    })),
    className: "vsx-activity-stream-comment-box-container",
    disableFormPageBlockAdjust: true,
    rowProps: {
      reverse: true,
      justify: "space-between",
      paddingLeft: "medium-large"
    },
    titleGrow: true
  }, {
    children: (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
      gap: "medium-large",
      padding: "medium-large",
      className: "vsx-activity-stream-comment-box",
      paddingBottom: "xl",
      paddingTop: "xs"
    }, {
      children: [visibilitySelection && options.length && (0, jsx_runtime_1.jsx)(Select_1.Select, {
        value: options.find(function (o) {
          return o.value === visibleTo;
        }),
        onChange: function (newValue) {
          return setVisibleTo(newValue.value);
        },
        options: options
      }), (0, jsx_runtime_1.jsx)(TextArea_1.TextArea, {
        value: text,
        placeholder: commentPlaceholder,
        style: {
          height: "64px",
          minHeight: "64px"
        },
        resize: "vertical",
        onChange: function (e) {
          return setText(e.currentTarget.value);
        }
      }), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-activity-stream-comment-box-title"
      }, {
        children: attachmentTitle
      })), (0, jsx_runtime_1.jsx)(MultiFileUpload_1.MultiFileUpload, __assign({
        dragDrop: true
      }, hook, multiFileUploadProps, {
        className: "vsx-activity-stream-comment-attachment"
      })), (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
        justify: "space-between",
        align: "end"
      }, {
        children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
          spinner: commentSubmitSpinner,
          type: "primary",
          disabled: commentSubmitDisabled || !((_b = comment.text) === null || _b === void 0 ? void 0 : _b.length) && !((_c = comment.attachment) === null || _c === void 0 ? void 0 : _c.length),
          onClick: _onCommentSubmit
        }, {
          children: commentSendButton
        }))]
      }))]
    }))
  }));
};
exports.ActivityStreamCommentBox = ActivityStreamCommentBox;